import { Survicate } from '@survicate/survicate-web-surveys-wrapper';
import { getSurvicateInstance, initSurvicate } from '@survicate/survicate-web-surveys-wrapper/widget_wrapper';
import { ReactNode, useEffect, useState } from 'react';

import { useRole } from '../common/hooks/useRole';
import AppSettings from '../constants';

import { SurvicateContext } from './SurvicateContext';

interface SurvicateContextProviderProps {
    children: ReactNode;
}

export const SurvicateContextProvider = ({ children }: SurvicateContextProviderProps) => {
    const role = useRole();

    const [survicate, setSurvicate] = useState<Survicate | null>(null);

    const SURVEY_DELAY_IN_MS = 15000; // 15 seconds

    useEffect(() => {
        initSurvicate({
            workspaceKey: AppSettings.survicateWorkspaceKey,
            disableTargeting: true,
            traits: {
                userId: role.user.id,
            },
        })
            .then(() => {
                const survicateInstance = getSurvicateInstance();
                setSurvicate(survicateInstance);

                if (role.isCustomer() && !role.hasAnyCompanyWriteRights()) {
                    setTimeout(() => {
                        survicateInstance?.showSurvey(AppSettings.survicateSurveyId.customer);
                    }, SURVEY_DELAY_IN_MS);
                }
            })
            // eslint-disable-next-line no-console
            .catch((error) => console.error(error));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <SurvicateContext.Provider value={survicate}>{children}</SurvicateContext.Provider>;
};
